import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ClientPortalUserAgreement } from '../../interfaces/configuration/client-portal-user-agreement';

@Injectable()

export class ClientPortalUserAgreementService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<ClientPortalUserAgreement[] | boolean> {
    return new Observable<ClientPortalUserAgreement[] | boolean>((o: Subscriber<ClientPortalUserAgreement[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.client-portal-user-agreement.index')).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<ClientPortalUserAgreement[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<ClientPortalUserAgreement | boolean> {
    return new Observable<ClientPortalUserAgreement | boolean>((o: Subscriber<ClientPortalUserAgreement | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.client-portal-user-agreement.read', {':id': id})).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<ClientPortalUserAgreement>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  create(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('configuration.client-portal-user-agreement.create'), formData);
  }
}
